"use client";

import * as Dialog from "@radix-ui/react-dialog";
import { cn } from "@/lib/utils";
import React from "react";

interface ModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  title,
  description,
  children,
  className,
}) => {
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        {/* Backdrop */}
        <Dialog.Overlay className="fixed inset-0 bg-black/60 backdrop-blur-sm z-40" />

        {/* Modal content */}
        <Dialog.Content
          className={cn(
            "fixed left-1/2 top-1/2 z-50 w-full max-w-md -translate-x-1/2 -translate-y-1/2 rounded-xl border border-primaryborder bg-background p-4  shadow-xl focus:outline-none",
            className
          )}
        >
          {/* Close Icon */}
          {/* <Dialog.Close asChild>
            <button
              className="absolute right-4 top-4 text-muted text-red-600 hover:text-white transition bg-red-600/20 p-1 rounded-full"
              aria-label="Close"
            >
              <IconX size={20} />
            </button>
          </Dialog.Close> */}

          <Dialog.Title className="sr-only">{title}</Dialog.Title>

          {/* Title */}
          {title && (
            <Dialog.Title className="text-lg font-semibold text-white mb-2">
              {title}
            </Dialog.Title>
          )}

          {/* Description */}
          <Dialog.Description className="text-sm text-muted mb-4">
            {description}
          </Dialog.Description>

          {/* Content */}
          <div>{children}</div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default Modal;
